import { Option } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { getTooltipContentByFieldName } from '../../../common/tooltip/tooltip-get-content';
import { FlexBox } from '../../shared-components/flex-box';
import { FormInput } from '../../shared-components/form/FormInput';
import { SelectOptions } from '../../shared-components/form/SelectOptions';
import { ValidationMessageList } from '../../shared-components/ValidationMessageList';
import './YourInformationSection.scss';

const YourInformationSectionImpl: React.FC = () => {
  const {
    nominationWizardPageUiStore,
  } = useStores();

  const isBeingValidated = nominationWizardPageUiStore.isBeingValidated('your-information');

  return (
    <FlexBox
      isFullWidth
      direction='column'
      className='your-information-section'
    >
        <FlexBox
          className='your-information-section__row'
          aligns='start'
          isFullWidth
          wrap
        >
          <FlexBox
            className='row__sub-row'
            aligns='start'
            isFullWidth
          >
            <SelectOptions
              className='field--prefix'
              validationMessage={
                isBeingValidated
                && nominationWizardPageUiStore.yourInformationValidation.fieldErrors.prefix?.length
                  ? (
                    <ValidationMessageList
                      messages={nominationWizardPageUiStore.yourInformationValidation.fieldErrors.prefix}
                    />
                  )
                  : undefined
              }
              label='Prefix'
              onOptionSelect={(optionData) => nominationWizardPageUiStore.setOwnerBodyRequest('prefix', optionData.optionValue || undefined)}
              dropdownProps={{
                inlinePopup: true,
                value: nominationWizardPageUiStore.nomination.owner.prefix || '',
                selectedOptions: nominationWizardPageUiStore.nomination.owner.prefix
                  ? [nominationWizardPageUiStore.nomination.owner.prefix]
                  : [],
              }}
            >
              <Option value='' text='' />
              <Option value='Mr.'>Mr.</Option>
              <Option value='Mrs.'>Mrs.</Option>
              <Option value='Ms.'>Ms.</Option>
            </SelectOptions>
            <FormInput
              required
              className='field--first-name'
              label='First name'
              tooltipText={getTooltipContentByFieldName('your-information', 'firstName')}
              validationMessage={
                isBeingValidated
                && nominationWizardPageUiStore.yourInformationValidation.fieldErrors.firstName?.length
                  ? (
                    <ValidationMessageList
                      messages={nominationWizardPageUiStore.yourInformationValidation.fieldErrors.firstName}
                    />
                  )
                  : undefined
              }
              onChange={(firstName) => nominationWizardPageUiStore.setOwnerBodyRequest('firstName', firstName)}
              inputProps={{
                type: 'text',
                maxLength: 100,
                value: nominationWizardPageUiStore.nomination.owner.firstName,
              }}
            />
          </FlexBox>

          <FormInput
            required
            label='Last name'
            tooltipText={getTooltipContentByFieldName('your-information', 'lastName')}
            validationMessage={
              isBeingValidated
              && nominationWizardPageUiStore.yourInformationValidation.fieldErrors.lastName?.length
                ? (
                  <ValidationMessageList
                    messages={nominationWizardPageUiStore.yourInformationValidation.fieldErrors.lastName}
                  />
                )
                : undefined
            }
            onChange={(lastName) => nominationWizardPageUiStore.setOwnerBodyRequest('lastName', lastName)}
            inputProps={{
              type: 'text',
              maxLength: 100,
              value: nominationWizardPageUiStore.nomination.owner.lastName,
            }}
          />
        </FlexBox>

        <FlexBox
          className='your-information-section__row'
          aligns='start'
          isFullWidth
        >
          <FormInput
            label='Title / Role'
            onChange={(title) => nominationWizardPageUiStore.setOwnerBodyRequest('title', title || undefined)}
            inputProps={{
              type: 'text',
              maxLength: 100,
              value: nominationWizardPageUiStore.nomination.owner.title || '',
            }}
          />
          <FormInput
            label='Email'
            tooltipText={getTooltipContentByFieldName('your-information', 'email')}
            inputProps={{
              disabled: true,
              type: 'text',
              value: nominationWizardPageUiStore.nomination.owner.emailAddress,
            }}
          />
        </FlexBox>
      </FlexBox>
  );
}

export const YourInformationSection = observer(YourInformationSectionImpl);
